<template>
	<div class="edit-formula">
		<NavBar v-if="admin" :admin="true" :items="items" />
		<Breadcrumbs v-else :items="items" />
		<v-main :class="admin ? 'mx-12' : 'pa-0'">
			<v-progress-linear indeterminate color="primary" v-if="!loaded"></v-progress-linear>
			<FormulaForm
				v-if="loaded"
				:product="product"
				:providers="providers"
				:productUnits="productUnits"
				:productProcessing="productProcessing"
				:edit="true"
				:admin="admin"
			/>
		</v-main>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NavBar from "@/components/authentication/NavBar.vue";
import FormulaForm from "@/components/products/FormulaForm.vue";
import axios from "axios";

export default {
	name: "EditFormula",
	components: {
		Breadcrumbs,
		NavBar,
		FormulaForm
	},
	data: () => ({
		product: {
			ingredients: [],
			indications_icd: [],
			contraindications_icd: [],
			information: {"pt":{}}
		},
		providers: [],
		productUnits: [],
		productProcessing: [],
		loaded: false
	}),
	computed: {
		admin() {
			return this.$store.getters.hasRole('admin');
		},
		isExternalEntity() {
			return this.$store.getters.isExternalEntity;
		},
		items() {
			return [
				... this.admin || !this.isExternalEntity ? [{
						text: this.$gettext("Dashboard"),
						disabled: false,
						link: true,
						to: this.admin ? { name: "dashboard" } : { name: "home" }
					}] : [],
				... !this.admin && !this.isExternalEntity ? [{
						text: this.$gettext("Treatments"),
						disabled: false,
						link: true,
						to: { name: "treatments" }
					}] :[],
				{
					text: this.$gettext("Chinese Materia Medica"),
					disabled: false,
					link: true,
					to: this.admin ? { name: "admin-cmm", params: { admin: true } } : { name: "cmm" }
				},
				{
					name: true,
					text: this.product.information ? this.product.information.pt.name : this.product.name,
					disabled: true,
					link: true
				},
				{
					text: this.$gettext("Edit"),
					disabled: true,
					link: true
				}
			]
		}
	},
	created() {
		const productId = this.$route.params.sid;
		axios
			.get("/mtc/formulas/" + productId + "/edit")
			.then(response => {
				console.log(response.data);
				this.product = response.data.product;
				this.providers = response.data.providers;
				this.providers.push({ id: -1, name: this.$gettext("Create Provider...") });
				this.productUnits = response.data.product_units;
				this.productProcessing = response.data.product_processing;
				this.loaded = true;
			})
			.catch(error => {
				console.log(error);
			});
	}
};
</script>
